<template>
   <base-nav class="navbar-top dashboard-navbar"
              id="navbar-main"
              :show-toggle-button="true"
              expand>
        <template slot="brand">
            <router-link :to="$route.path"
                         class="navbar-brand-desktop d-none d-lg-block">
                {{$route.name}}
            </router-link>
        </template>
        <ul class="navbar-nav align-items-center">
            <li class="nav-item dropdown">
                <base-dropdown class="dashboard-user-menu" v-if="accessDetails">
                    <a href="#" class="dashboard-user-trigger" slot="title" @click.prevent>
                        <span class="dashboard-user-avatar">
                            <img v-if="accessDetails.passportPath" alt="" :src="accessDetails.passportPath" />
                            <img v-else src="img/brand/loguser.png" alt="" />
                        </span>
                       <div class="dashboard-user-copy">
                            <span class="dashboard-user-name">{{ accessDetails.fullName }}</span>
                            <span class="dashboard-user-label">Account</span>
                        </div>
                        <i class="fa fa-chevron-down dashboard-user-chevron" aria-hidden="true"></i>
                    </a>

                    <template>
                       <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome!
                               <span class="ml-1">{{ accessDetails.fullName }}</span>
                            </h6>
                        </div>
                        <div class="dropdown-divider"></div>
                        <router-link to="/user-profile" class="dropdown-item"> <i class="fa fa-user"></i>
                            <span>Profile</span></router-link>

                        <div class="dropdown-divider"></div>
                        <button type="button" class="dropdown-item" @click="logout">
                            <i class="fa fa-right-from-bracket"></i>
                            <span>Logout</span>
                        </button>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>

<script>
export default {
    data() {
        return {
            activeNotifications: false,
            showMenu: false,
            searchQuery: '',
            accessDetails: null
        };
    },
    methods: {
        logout() {
            this.$store.dispatch('auth/Logout')
                .then(() => {
                    this.$router.push('/login')
                })
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        }
    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
       
    },
};
</script>

<style scoped>

.dashboard-navbar {
    min-height: 4.5rem;
    padding-top: 0.55rem !important;
    padding-bottom: 0.55rem !important;
    border-bottom: 1px solid rgba(148, 163, 184, 0.16);
    box-shadow: 0 5px 18px rgba(15, 23, 42, 0.07);
    animation: dashboard-navbar-enter 360ms cubic-bezier(0.2, 0.75, 0.25, 1) both;
}

::v-deep .dashboard-navbar .navbar-main-container {
    padding-left: clamp(0.75rem, 2vw, 1.75rem) !important;
    padding-right: clamp(0.75rem, 2vw, 1.75rem) !important;
}

::v-deep .dashboard-navbar .navbar-row-container {
    min-width: 0;
    gap: clamp(0.5rem, 1.25vw, 1rem);
}

::v-deep .dashboard-navbar .navbar-nav {
    min-width: 0;
}

::v-deep .dashboard-navbar .nav-item.dropdown {
    position: relative;
}

.dashboard-user-trigger {
    display: inline-flex;
    align-items: center;
    gap: 0.7rem;
    min-height: 2.75rem;
    max-width: min(17rem, 42vw);
    padding: 0.3rem 0.65rem 0.3rem 0.35rem;
    color: var(--header-text) !important;
    text-decoration: none !important;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    transition: background-color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.dashboard-user-trigger:hover,
.dashboard-user-trigger:focus-visible {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
    outline: none;
}

.dashboard-user-avatar {
    display: inline-flex;
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.72);
    border-radius: 50%;
    background: #e8eef8;
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.16);
}

.dashboard-user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.dashboard-user-copy {
    display: flex;
    min-width: 0;
    flex-direction: column;
    line-height: 1.2;
}

.dashboard-user-name {
    max-width: 11rem;
    overflow: hidden;
    font-size: 0.82rem;
    font-weight: 650;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dashboard-user-label {
    margin-top: 0.12rem;
    font-size: 0.68rem;
    opacity: 0.72;
}

.dashboard-user-chevron {
    margin-left: 0.1rem;
    font-size: 0.65rem;
    opacity: 0.75;
    transition: transform 180ms ease;
}

::v-deep .dashboard-user-menu.show .dashboard-user-chevron {
    transform: rotate(180deg);
}

.navbar-brand-mobile {
    font-size: 0.9rem;
    white-space: nowrap;
}

/* Make brand text responsive */
::v-deep .navbar-brand-desktop {
    align-items: center;
    max-width: min(15rem, 30vw);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: clamp(1rem, 1.5vw, 1.35rem) !important;
    padding: 0.5rem 0.75rem !important;
    letter-spacing: 0.5px;
    font-weight: 600 !important;
    margin: 0 0.75rem 0 0 !important;
}

/* Improve dropdown menu positioning and responsiveness */
::v-deep .nav-item.dropdown .dropdown-menu {
    min-width: 260px !important;
    max-width: min(280px, calc(100vw - 1rem));
    right: 0 !important;
    left: auto !important;
    top: 100% !important;
    margin-top: 0.65rem;
    padding: 0.4rem;
    box-shadow: 0 16px 38px rgba(15, 23, 42, 0.18) !important;
    border: 1px solid rgba(148, 163, 184, 0.2) !important;
    border-radius: 0.85rem !important;
    transform-origin: top right;
    animation: dashboard-menu-enter 160ms ease-out both;
}

/* Better dropdown item spacing */
::v-deep .dropdown-item {
    min-height: 2.65rem;
    padding: 0.65rem 0.85rem !important;
    font-size: 0.95rem;
    display: flex !important;
    align-items: center !important;
    gap: 0.75rem;
}

::v-deep .dropdown-item i {
    width: 18px;
    text-align: center;
}

/* Better dropdown header styling */
::v-deep .dropdown-header.noti-title {
    padding: 0.8rem 0.85rem !important;
}

::v-deep .dropdown-header h6 {
    font-size: 0.95rem !important;
    word-wrap: break-word !important;
    white-space: normal !important;
}

/* Keep the avatar menu readable in every header theme. */
::v-deep .dashboard-navbar .dropdown-menu {
        background: #ffffff !important;
        border: 1px solid #dfe5ee !important;
}

::v-deep .dashboard-navbar .dropdown-header,
::v-deep .dashboard-navbar .noti-title h6 {
        color: #344054 !important;
        background: #ffffff !important;
}

::v-deep .dashboard-navbar .dropdown-item {
        color: #344054 !important;
        background: #ffffff !important;
}

::v-deep .dashboard-navbar .dropdown-item i {
        color: #2f6fd6 !important;
}

::v-deep .dashboard-navbar .dropdown-item:hover,
::v-deep .dashboard-navbar .dropdown-item:focus {
        color: #1f2937 !important;
        background: #eef4ff !important;
}

@keyframes dashboard-navbar-enter {
    from { opacity: 0; transform: translateY(-0.4rem); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes dashboard-menu-enter {
    from { opacity: 0; transform: translateY(-0.35rem) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
}

@media (max-width: 767.98px) {
    .dashboard-navbar {
        min-height: 3.9rem;
        padding-top: 0.35rem !important;
        padding-bottom: 0.35rem !important;
    }

    .dashboard-user-trigger {
        gap: 0.45rem;
        max-width: 44vw;
        padding-right: 0.45rem;
    }

    .dashboard-user-avatar {
        flex-basis: 1.85rem;
        width: 1.85rem;
        height: 1.85rem;
    }

    .dashboard-user-name {
        max-width: 5.5rem;
        font-size: 0.75rem;
    }

    .dashboard-user-label {
        display: none;
    }

    .dashboard-user-chevron {
        font-size: 0.58rem;
    }

    ::v-deep .nav-item.dropdown .dropdown-menu {
        min-width: min(260px, calc(100vw - 1rem)) !important;
    }

    ::v-deep .dashboard-user-menu {
        display: none !important;
    }
}

@media (prefers-reduced-motion: reduce) {
    .dashboard-navbar,
    .dashboard-user-trigger,
    .dashboard-user-chevron,
    ::v-deep .nav-item.dropdown .dropdown-menu {
        animation: none !important;
        transition: none !important;
    }
}

/* Keep the title legible without crowding the profile control. */
@media (max-width: 1400px) {
    ::v-deep .navbar-brand-desktop {
        max-width: min(15rem, 28vw);
    }
}
</style>
